import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/content';
import { OFFER_ANCHOR } from '../data/config';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const reduce = useReducedMotion();
  useEffect(() => {
    if (dismissed) return;
    let timer: ReturnType<typeof setTimeout>;
    const show = () => {
      setVisible(true);
      timer = setTimeout(hide, 5000);
    };
    const hide = () => {
      setVisible(false);
      timer = setTimeout(() => {
        setIndex(i => (i + 1) % recentBuyers.length);
        show();
      }, 8000);
    };
    timer = setTimeout(show, 4000);
    return () => clearTimeout(timer);
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed bottom-3 left-3 z-50 w-[240px] sm:bottom-4 sm:left-4" aria-live="polite" data-id="element-194" data-mp="1gwufeb0wwgi7">
      <AnimatePresence data-id="element-195" data-mp="117frg5fx9zsx">
        {visible && !dismissed && <motion.div key={buyer.name} initial={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 14,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 10
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative" data-id="element-196" data-mp="114tj43l7jg9n">
            <a href={OFFER_ANCHOR} className="flex items-start gap-2.5 rounded-lg border border-teal-700/20 bg-white px-3 py-2 shadow-lg shadow-blue-950/10" data-id="element-197" data-mp="i9v08rpoqp55">
              <span className="mt-0.5 flex h-[20px] w-[20px] shrink-0 items-center justify-center rounded-full bg-green-600" data-id="element-198" data-mp="s4wq5prsbv8s">
                <CheckIcon className="h-3 w-3 text-white" strokeWidth={4} aria-hidden data-id="element-199" data-mp="23ld8prymyrzv" />
              </span>
              <span className="min-w-0 leading-tight" data-id="element-200" data-mp="2aotio8qhnng1">
                <span className="block text-[11px] font-extrabold uppercase text-blue-950" data-id="element-201" data-mp="2aobempxl44xk">{buyer.name}</span>
                <span className="block text-[10px] text-slate-600" data-id="element-202" data-mp="2fpr1mnjbolil">{buyer.place}</span>
                <span className="mt-1 block text-[10.5px] font-semibold text-teal-700" data-id="element-203" data-mp="2knirlc0epxk5">
                  Just purchased the Pediatric OT Therapy System™
                </span>
                <span className="block text-[9.5px] font-extrabold uppercase text-amber-700" data-id="element-204" data-mp="1rz4vj1svpbb8">
                  {buyer.minutes} minutes ago
                </span>
              </span>
            </a>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full border border-teal-700/20 bg-white text-blue-950" data-id="element-205" data-mp="21v83ioaew463">
              <XIcon className="h-3 w-3" strokeWidth={3} data-id="element-206" data-mp="1e5428nkp4gi9" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}